import p5 from 'p5'

function headerBigAnimation() {
  let p5c = $('.js-container-p5-header')
  let heroSketch

  let btcPath = p5c.data('img-src')

  let sketch = function (p) {
    var containerWidth = p5c.width();
    var containerHeight = p5c.height();

    /* eslint-disable */
    p5.disableFriendlyErrors = true;
    var btc;
    var Stars = [];
    var smallSize = 100;
    let sizeCoef = 1.7
    let fromTopCoef = 2
    if (window.innerWidth < 1200){
      sizeCoef = 1.5
    }
    if (window.innerWidth < 700){
      sizeCoef = 1
    }
    let logoWidth = (containerWidth / sizeCoef)
    var scaleFactor = logoWidth / smallSize;
    var starsColor = ['#FFFFFF', '#FDE4C7', '#FFFFFF'];

    let logoLeft = 0
    if (window.innerWidth < 1200){
      logoLeft = containerWidth / 2 - logoWidth / 2
    }

    var translate = {
      x: logoLeft,
      y: containerHeight / fromTopCoef - (logoWidth / 2) - 20
    };
    var positions = {
      'btc': []
    };

    var RandomStars = [];

    function translatePoint (vector) {
      var newX = (vector.x * scaleFactor) + translate.x;
      var newY = (vector.y * scaleFactor) + translate.y;
      var newVec = p.createVector(newX, newY);
      return newVec;
    }

    var center = translatePoint(p.createVector(smallSize / 2, smallSize / 2));

    var bgColor = p.color('#F7931E');
    let size1 = 2
    let size2 = 4
    if (window.innerWidth < 1200) size2 = 3

    // PARTICLE OF THE IMAGE
    function Star (vector) {
      this.x = vector.x;
      this.y = vector.y;
      this.pos = p.createVector(p.random(containerWidth * -1.2, containerWidth * 1.2), p.random(containerWidth * -1.2, containerHeight * 1.2)); // initial position
      this.target = p.createVector(this.x, this.y);
      this.color = p.random(starsColor);
      this.size = p.random(size1, size2);
      this.vel = p.createVector(p.random(-5, 6), p.random(-4, 6));
      this.acc = p.createVector();
      this.maxSpeed = 10;
      this.maxForce = 2;
      this.weight = p.random(0.5, 2.5);
      this.allowRepulse = false;
      this.goingCenter = false;

      this.alpha;
    }

    Star.prototype.update = function () {
      this.pos.add(this.vel);
      this.vel.add(this.acc);
      this.alpha;
      this.acc.mult(0);
    }

    Star.prototype.move = function () {
      var attract = this.attract(this.target);
      this.appForce(attract);

      var mouse = p.createVector(p.mouseX, p.mouseY);
      var repulse = this.repulse(mouse);
      this.appForce(repulse);

    }

    Star.prototype.appForce = function (value) {
      this.acc.add(value);
    }

    Star.prototype.modAlpha = function () {
      var desired = p5.Vector.sub(this.target, this.pos);
      var d = desired.mag();
      var opacity = p.map(d, 0, 800, 255, 0);
      return opacity;
    }

    Star.prototype.attract = function (target) {
      var desired = p5.Vector.sub(target, this.pos);
      var d = desired.mag(); // distance between target and position
      if (d < 100 && !this.goingCenter) {
        // Repulse - hover uz vietas kustiba
        this.vel.limit(5); // izjauksanas atrums un jauksanas kad hoverots atrums, def=10
        if (d < 10 && !(this.allowRepulse)) { // repulse attalums def=10
          var G = 70;
          var distancesq = desired.magSq();

          var force = distancesq / G;
          desired.setMag(force * this.weight);
          this.vel.limit(.7); // burtu jauksanas daudzums
          return desired;
        }
      } else {
        // saskriesana raksta
        var G = 9999999999999999999999; // cik atri saskrien vietas
        var distancesq = desired.magSq();
        var force = G / distancesq;
        desired.setMag(force);
        this.vel.limit(15);
        return desired;
      }
    }

    // hover uz raksta
    Star.prototype.repulse = function (target) {
      var desired = p5.Vector.sub(target, this.pos);
      var d = desired.mag();
      if (d < 80) { // peles attalums no kura sak jaukt burtus. def=80
        this.allowRepulse = true;
        var distancesq = desired.magSq();
        var force = (500 / distancesq) * this.weight; // maina iztuksota cauruma lielumu uz hover def=5000
        desired.setMag(-force);
        return desired;
      } else {
        this.allowRepulse = false;
        return p.createVector(0, 0);
      }
    }

    Star.prototype.render = function () {
      p.noStroke();
      var color = p.color(this.color);
      color.setAlpha(this.modAlpha());
      p.fill(color);
      p.ellipse(this.pos.x, this.pos.y, this.size, this.size);
    }

    // FONA PUNKTI
    function RandomStar () {
      this.pos = p.createVector(p.random(containerWidth), p.random(containerHeight));
      this.vel = p.createVector(p.random(-3, 3), p.random(-3, 3));  // fona punktu kustibas atrums def= (-3,3) (-3,3)
      this.weight = p.random(0.5, 1.5);
      this.size = p.random(2, 4);
      this.corner = p.createVector(0, 0);
      this.color = p.color(p.random(starsColor));
      this.alpha;
    }

    RandomStar.prototype.modAlpha = function (dist) {
      var alpha = p.map(dist, 0, containerWidth * 0.8, 0, 255);
      return alpha;

    }

    RandomStar.prototype.checkBoundaries = function () {
      if ((this.pos.x > containerWidth) || (this.pos.x < 0)) {
        this.vel.x = this.vel.x * (-1);
      }
      if ((this.pos.y > containerHeight) || (this.pos.y < 0)) {
        this.vel.y = this.vel.y * (-1);
      }
    }

    RandomStar.prototype.update = function () {
      this.checkBoundaries();
      this.pos.add(this.vel);

      var dist = this.pos.sub(this.corner);
      this.alpha = this.modAlpha(dist.mag());
    }

    RandomStar.prototype.render = function () {
      var c = this.color;
      c.setAlpha(this.alpha);
      p.fill(c);
      p.ellipse(this.pos.x, this.pos.y, this.size, this.size);
    }

    // CREATE RANDOMSTAR
    let bgPointsCount = 100
    if (window.outerWidth < 1400) bgPointsCount = 80
    if (window.outerWidth < 1200) bgPointsCount = 20

    for (var i = 0; i < bgPointsCount; i++) { // fona punktu daudzums, def=150
      var randStar = new RandomStar();
      RandomStars.push(randStar);
    }

    let pointsPercentage = 40
    if (window.outerWidth < 1400) pointsPercentage = 30
    if (window.outerWidth < 1200) pointsPercentage = 25
    if (window.outerWidth < 700) pointsPercentage = 18

    p.setup = function () {
      p.createCanvas(containerWidth, containerHeight, 'WEBGL');
      p.pixelDensity(1);
      p.background(bgColor);
      var btc = p.loadImage(btcPath, function (img) {
        // p.image(img, 0, 0);
        btc.resize(smallSize, smallSize);
        btc.loadPixels();
        for (var x = 0; x < btc.width; x++) {
          for (var y = 0; y < btc.height; y++) {
            var index = (x + y * btc.width) * 4;
            if (btc.pixels[index] < 200) { // if channel red < 200 == black in this case
              if (Math.round(p.random(100)) < pointsPercentage) { //get only % of the points, randomly
                var initVec = p.createVector(x, y);
                var pos = translatePoint(initVec);
                positions.btc.push(pos);
                Stars.push(new Star(pos));
              }
            }
          }
        }
      }); // close callback loader image
      p.pixelDensity();
    }

    p.draw = function () {
      p.background(bgColor);
      for (var k = 0; k < Stars.length; k++) {
        Stars[k].move();
        Stars[k].update();
        Stars[k].render();
      }
      for (let j = 0; j < RandomStars.length; j++) {
        RandomStars[j].update();
        RandomStars[j].render();
      }
    }

    p.windowResized = function () {
      containerWidth = p5c.width();
      containerHeight = p5c.height();
      p.resizeCanvas(containerWidth, containerHeight);
    }

  };


  heroSketch = new p5(sketch, document.querySelector('.js-container-p5-header'));
  let p5Generated = 1


  $(window).scroll(function () {
    let animationC = $('.js-container-p5-header')
    let top = $(window).scrollTop()

    if (top > $(window).height()){
      if (p5Generated){
        heroSketch.remove()
        p5Generated = 0
      }
    } else {
      if (!p5Generated){
        if (!animationC.find('canvas').length) {
          heroSketch = new p5(sketch, document.querySelector('.js-container-p5-header'));
        }
        p5Generated = 1
      }
    }
  })

}

if ($('.header-block').length) headerBigAnimation()
